module.exports = __webpack_public_path__ + "img/face-woozy.a37281a9.svg";